import cx from 'classnames';
import { forwardRef } from 'react';

function Input({ className, component: Component = 'input', error, ...props }, ref) {
  return (
    <Component
      ref={ref}
      className={cx(
        'min-h-10 rounded-md bg-neutral-50 placeholder-neutral-400 transition duration-150 focus:outline-none focus:ring-1 disabled:border-neutral-200 disabled:bg-neutral-100 disabled:text-black',
        {
          'border-neutral-300 focus:border-primary-400 focus:ring-primary-400': !error,
          'border-red-500 focus:border-red-500 focus:ring-red-500': error,
          'p-2 text-neutral-500 file:mr-4 file:rounded-md file:border-0 file:bg-primary-500/10 file:py-2 file:px-4 file:font-medium file:text-primary-500 file:transition hover:file:bg-primary-500/20':
            props.type === 'file',
        },
        className
      )}
      {...props}
    />
  );
}

export default forwardRef(Input);
